import { useToast } from '@chakra-ui/react';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { getCargaSAP, listCompaniesCargaSAP } from '~/services';
import { SelectItem } from '~/types';
import { CargaSAP } from '~/types/cargaSAP';

export function useJSON(
  id: string,
  options: UseQueryOptions<CargaSAP, unknown> = {},
): UseQueryResult<CargaSAP> {
  const toast = useToast();

  console.log('useJSON()');

  return useQuery<CargaSAP, unknown>(['companies', id], () => getCargaSAP(id), {
    staleTime: 1000 * 60 * 1, // 10 minutes
    ...options,
    onError: () => {
      toast({
        title: 'Erro',
        description: 'Erro buscar dados',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    },
  });
}

// export function useEmpresas(
//   options: UseQueryOptions<CargaSAP, unknown> = {},
// ): UseQueryResult<CargaSAP> {
//   const toast = useToast();

//   return useQuery<CargaSAP, unknown>(['carga'], () => listEmpresasCargaSAP(), {
//     staleTime: 1000 * 60 * 1, // 10 minutes
//     ...options,
//     onError: () => {
//       toast({
//         title: 'Erro',
//         description: 'Erro buscar dados',
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//         position: 'top-right',
//       });
//     },
//   });
// }

export function useCompanyAsSelect(
  options: UseQueryOptions<SelectItem[], unknown> = {},
): UseQueryResult<SelectItem[], unknown> {
  return useQuery<SelectItem[], unknown>(
    ['equipmentTypesSelect'],
    () => listCompaniesCargaSAP(),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}
